import { get, post } from '@/api/request'
import { utilities } from '@billow/js-helpers'

export const checkForExistence = (companyName, success, failure) => post(
  `/api/company/exists`,
  { name: companyName },
  success, failure
)

export const createConnection = (payload, success, failure) => post(
  '/api/connections',
  payload,
  success, failure
)

export const updateCompany = (company, success, failure) => post(
  `/api/connections/${company.id}`,
  company,
  success, failure
)

export const loadList = (success, failure) => get(
  `/api/connections/list`,
  success, failure
)

export const loadCompany = (companyId, success, failure) => get(
  `/connections/${companyId}`,
  success, failure
)

export const loadOverview = (companyId, success, failure) => get(
  `/connections/${companyId}/overview`,
  success, failure
)

export const createUser = ({ company, user }, success, failure) => post(
  `/connections/${company}/users`,
  user,
  success, failure
)

export const uploadLogo = ({ company, file }, success, failure) => post(
  `/connections/${company}/logo`,
  utilities.formData({ file }),
  success, failure
)

export const allowAbility = ({ ability, company }, success, failure) => post(
  `/connections/${company}/allow`,
  ability,
  success, failure
)

export const disallowAbility = ({ ability, company }, success, failure) => post(
  `/connections/${company}/disallow`,
  ability,
  success, failure
)

export const requestConnection = ({ company, message }, success, failure) => post(
  `/connections/${company}/request`,
  { message },
  success, failure
)

export const approveConnection = (requestId, success, failure) => post(
  `/connection-requests/${requestId}/approve`,
  {},
  success, failure
)

export const rejectConnection = (requestId, success, failure) => post(
  `/connection-requests/${requestId}/reject`,
  {},
  success, failure
)

export const severConnection = (companyId, success, failure) => post(
  `/connections/${companyId}/severe`,
  {},
  success, failure
)
